import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { GetQuizDetailApi } from "../redux/actions/teams/members/GetQuizDetailsActions";
import { getImageUrl } from "../helpers/utils";

const QuizDetails = () => {
  const { id } = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const quizData = location.state || {};
  const [details, setDetails] = useState(quizData);
  const [expandedQuestions, setExpandedQuestions] = useState({});
  const [showAll, setShowAll] = useState(false);

  const { response: quizDetailsResponse, loading, error } = useSelector(
    (state) => state.QuizDetails
  );

  

  useEffect(() => {
    if (id) {
      dispatch(GetQuizDetailApi(id));
    }
  }, [dispatch, id]);

  useEffect(() => {
    if (quizDetailsResponse?.status && quizDetailsResponse.data) {
      setDetails(quizDetailsResponse.data);
    }
  }, [quizDetailsResponse]);

  const toggleExpand = (index) => {
    setExpandedQuestions((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  if (loading)
    return <div style={{ padding: 20, textAlign: "center" }}>Loading...</div>;
  if (error)
    return (
      <div style={{ padding: 20, textAlign: "center" }}>
        Error loading quiz details: {error?.data || "Unknown error"}
      </div>
    );

  return (
    <div className="content-wrapper" style={{ backgroundColor: "#f5f5f5" }}>
      <section className="main-section">
        <div className="container py-4">
          <div className="row">
            <div className="col-12">
              <div
                style={{
                  padding: "30px",
                  backgroundColor: "#fff",
                  color: "#333",
                  borderRadius: "8px",
                  width: "100%",
                }}
              >
                {/* Status in top-right */}
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  {details?.statusss === 1 ? (
                    <span style={{ color: "green", fontWeight: "bold" }}>
                      ● Active
                    </span>
                  ) : (
                    <span style={{ color: "red", fontWeight: "bold" }}>
                      ● Inactive
                    </span> 
                  )}
                </div>
                {/* Quiz Image */}
                <div style={{ textAlign: "center", marginBottom: "20px" }}>
                  <img
                    src={getImageUrl(details?.quiz_image, `${process.env.REACT_APP_BACKEND_PRODUCTION_URL}/uploads/20250912T082219636Z821019_marathonmindset.png`)}
                    alt="Quiz"
                    style={{
                      maxWidth: "200px",
                      height: "auto",
                      borderRadius: "6px",
                    }}
                  />
                </div>

                {/* Quiz Info */}
                <div className="row g-3 mb-4">
                  <div className="col-12 col-md-6">
                    <h5 className="fw-bold text-secondary">Quiz Category</h5>
                    <p>{details?.category_name || "N/A"}</p>
                  </div>
                  <div className="col-12 col-md-6">
                    <h5 className="fw-bold text-secondary">Quiz Name</h5>
                    <p>{details?.quiz_name || "N/A"}</p>
                  </div>
                  <div className="col-12">
                    <h5 className="fw-bold text-secondary">Quiz Description</h5>
                    <p>{details?.description || "N/A"}</p>
                  </div>
                  <div className="col-12">
                      <h5 className="fw-bold text-secondary">Tips & Guidelines</h5>
                      {details?.tips && details.tips.length > 0 ? (
                        <ul>
                          {details.tips.map((tip, index) => (
                            <li key={index}>{tip}</li>
                          ))}
                        </ul>
                      ) : (
                        <p>N/A</p>
                      )}
                    </div>

                

                      <div className="col-12">
                        <h5 className="fw-bold text-secondary">Based on trusted NHS Guidance</h5>
                        {details?.nhs_guidance && details.nhs_guidance.length > 0 ? (
                          <ul>
                            {details.nhs_guidance.map((item, index) => {
                              const linkText = typeof item === 'object' ? item.text : item;
                              const linkUrl = typeof item === 'object' ? item.url : item;
                              
                              return (
                                <li key={index} className="mb-2">
                                  <a 
                                    href={linkUrl}
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="text-primary text-decoration-none fw-bold"
                                    style={{ cursor: 'pointer', fontSize: '1.1rem' }}
                                  >
                                    {linkText}
                                  </a>
                                </li>
                              );
                            })}
                          </ul>
                        ) : (
                          <p>N/A</p>
                        )}
                      </div>
                  <div className="col-6 col-md-4">
                    <h5 className="fw-bold text-secondary">Total Marks</h5>
                    <p>{details?.total_marks}</p>
                  </div>
                  <div className="col-6 col-md-4">
                    <h5 className="fw-bold text-secondary">
                      Total Questions
                    </h5>
                    <p>{details?.total_questions}</p>
                  </div>
                </div>

                {/* Questions */}
                <h5 className="fw-bold mb-3">Questions</h5>
               {details?.questions?.length > 0 ? (
                <>
                  {(showAll
                    ? details.questions
                    : details.questions.slice(0, 3)
                  ).map((q, index) => (
                    <div
                      key={q._id || index}
                      style={{
                        border: "1px solid #eee",
                        borderRadius: "6px",
                        padding: "15px",
                        marginBottom: "10px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                        onClick={() => toggleExpand(index)}
                      >
                        <div>
                          <p style={{ margin: 0, fontWeight: "bold" }}>
                            {index + 1}. {q.question}
                          </p>
                          <small className="text-muted">
                            Type: {q.question_type === "mcq" ? "MCQ" : "True/False"}
                          </small>
                        </div>
                        <span>{expandedQuestions[index] ? "▲" : "▼"}</span>
                      </div>

                      {expandedQuestions[index] && (
                        <div className="mt-3">
                          {/* Display correct answer */}
                          <p>
                            <strong>Correct Answer:</strong>{" "}
                            {q.question_type === "mcq" 
                              ? q.options?.[q.correct_answer] || "N/A"
                              : q.true_false?.[q.correct_answer] || "N/A"}
                          </p>
                          
                          {/* Display options based on question type */}
                          {q.question_type === "mcq" ? (
                            <div className="row">
                              <div className="col-6">
                                <p><strong>Option A:</strong> {q.options?.a}</p>
                              </div>
                              <div className="col-6">
                                <p><strong>Option B:</strong> {q.options?.b}</p>
                              </div>
                              <div className="col-6">
                                <p><strong>Option C:</strong> {q.options?.c}</p>
                              </div>
                              <div className="col-6">
                                <p><strong>Option D:</strong> {q.options?.d}</p>
                              </div>
                            </div>
                          ) : (
                            <div className="row">
                              <div className="col-6">
                                <p><strong>True:</strong> {q.true_false?.a || "True"}</p>
                              </div>
                              <div className="col-6">
                                <p><strong>False:</strong> {q.true_false?.b || "False"}</p>
                              </div>
                            </div>
                          )}
                          
                          {q.explanation && (
                            <p>
                              <strong>Explanation:</strong> {q.explanation}
                            </p>
                          )}
                        </div>
                      )}
                    </div>
                  ))}

                  {/* See More / See Less */}
                  {details.questions.length > 3 && (
                    <div style={{ textAlign: "right", marginTop: "10px" }}>
                      <button
                        className="btn btn-outline-primary btn-sm"
                        onClick={() => setShowAll(!showAll)}
                      >
                        {showAll ? "See Less" : "See More"}
                      </button>
                    </div>
                  )}
                </>
                ) : (
                  <p>No questions available</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default QuizDetails;
